import { scrollTargetElementPlugin } from "./ScrollTargetElement.js";
const withScrollTargets = (editor) => {
  editor.registerElement(scrollTargetElementPlugin);
  return editor;
};
export {
  withScrollTargets
};
//# sourceMappingURL=withScrollTargets.js.map
